import { GameVars } from "./../../../GameVars";
import { GameConstants } from "./../../../GameConstants";
import { ZoneProgress } from "../../../../types/tower-defense";
import { MapButton } from "./MapButton";

export class MapLayer extends Phaser.GameObjects.Container {

    public zone: ZoneProgress;
    public scarf: Phaser.GameObjects.Image;
    public scarfText: Phaser.GameObjects.Image;
    public mapButtons: MapButton[];

    constructor(scene: Phaser.Scene, index: number) {

        super(scene);

        this.zone = GameVars.gameData.progression[index];
        this.mapButtons = [];

        this.y = GameConstants.GAME_HEIGHT;

        let bck = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_5", "table_background_09");
        bck.setOrigin(.5, 1);
        this.add(bck);

        let centerX = - 290 * GameVars.scaleX + 280 * GameVars.scaleX + (GameConstants.GAME_WIDTH - 280 * GameVars.scaleX) / 2;
        let centerY = this.y - 370;

        const shape = this.scene.add.graphics();
        shape.fillRect( centerX, centerY, 580 * GameVars.scaleX, 220);
        shape.fillTriangle(centerX + (290 * 2) * GameVars.scaleX, centerY, centerX + (290 * 2) * GameVars.scaleX, centerY + 220, centerX + (290 * 2 + 100) * GameVars.scaleX, centerY + 220);
        shape.fillTriangle(centerX, centerY, centerX, centerY + 220, centerX - 150 * GameVars.scaleX, centerY + 220);
        
        const mask = shape.createGeometryMask();

        // map texture
        const textureContainer = new Phaser.GameObjects.Container(this.scene, 0, -200);
        textureContainer.setMask(mask);
        this.add(textureContainer);

        for (let i = 0; i < 3; i++) {

            let texture = new Phaser.GameObjects.Image(this.scene, -124 + i * 247, -50, "texture_atlas_5", "texture_map_0" + (index + 1));
            texture.setOrigin(1, .5);
            textureContainer.add(texture);
        }

        this.visible = false;

        let positions1 = [-250, -200, -280, -230, -270, -250];
        let positions2 = [-250, -230, -240, -210, -230, -250];

        let dotPoints1 = [
            {x: -356, y: -253},
            {x: -270, y: -227},
            {x: -240, y: -215},
            {x: -149, y: -226},
            {x: -128, y: -244},
            {x: -107, y: -260},
            {x: -30, y: -260},
            {x: 0, y: -248},
            {x: 98, y: -245},
            {x: 123, y: -254},
            {x: 214, y: -264},
            {x: 242, y: -257},
            {x: 336, y: -253},
            {x: 362, y: -253}];

        let dotPoints2 = [
            {x: -356, y: -253},
            {x: -265, y: -245},
            {x: -237, y: -239},
            {x: -145, y: -237},
            {x: -116, y: -243},
            {x: -27, y: -227},
            {x: 0, y: -217},
            {x: 97, y: -215},
            {x: 124, y: -220},
            {x: 217, y: -239},
            {x: 242, y: -244},
            {x: 336, y: -253},
            {x: 362, y: -253}];

        for (let i = 0; i < this.zone.mapsProgress.length; i++) {
            
            const mapButton = new MapButton(this.scene, 120 * i - (this.zone.mapsProgress.length / 2 - .5) * 120 - 10, index % 2 ? positions1[i] : positions2[i], this.zone.mapsProgress[i], index, i);
            this.add(mapButton);
            this.mapButtons.push(mapButton);
        }

        let dots = index % 2 ? dotPoints1 : dotPoints2;

        for (let i = 0; i < dots.length; i++) {

            if (index === 0 && i === 0) {
                continue;
            }

            if (index === 4 && (i === dots.length - 1 || i === dots.length - 2 )) {
                continue;
            }

            let dot = new Phaser.GameObjects.Image(this.scene, dots[i].x, dots[i].y, "texture_atlas_1", "map_dot");
            this.add(dot);
        }

        this.scarf = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "campaign_" + (index + 1));
        this.scarf.setOrigin(.5, 1);
        this.add(this.scarf);

        this.scarfText = new Phaser.GameObjects.Image(this.scene, 0, -2, "texture_atlas_1", "campaign_text_" + (index + 1));
        this.scarfText.setOrigin(.5, 1);
        this.add(this.scarfText);
    }

    public shake(): void {

        for (let i = 0; i < this.mapButtons.length; i ++) {

            this.scene.tweens.add({
                targets: this.mapButtons[i],
                y: this.mapButtons[i].y - 5 - 10 * Math.random(),
                angle: i % 2 ? 5 : -5,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 200,
                yoyo: true
            });
        }
    }

    public show(left?: boolean): void {

        this.x = left ? -200 : 200;
        this.visible = true;
        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            x: 0,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 400
        });

        this.scarf.alpha = 0;
        this.scarf.y = 15;

        this.scarfText.alpha = 0;
        this.scarfText.y = 15;

        this.scene.tweens.add({
            targets: this.scarf,
            y: 0,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 450,
            delay: 400
        });

        this.scene.tweens.add({
            targets: this.scarfText,
            y: -2,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 450,
            delay: 400
        });
    }

    public hide(left?: boolean): void {

        this.scarf.alpha = 0;
        this.scarfText.alpha = 0;

        this.alpha = 1;

        this.scene.tweens.add({
            targets: this,
            x: left ? 200 : -200,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 400,
            onComplete: () => {
                this.visible = false;
                this.x = 0;
            },
            onCompleteScope: this
        });
    }

    public showLevelCompleted(): void {

        this.mapButtons[GameVars.levelCompleted.map].showLevelCompleted();
    }

    public unlockNextLevel(): void {

        if (GameVars.levelCompleted.map === 5) {
            this.mapButtons[0].unlockNextLevel();
        } else {
            this.mapButtons[GameVars.levelCompleted.map + 1].unlockNextLevel();
        }
    }
}
